import { useState } from 'react';
import { Link } from 'react-router-dom';
import { hotTags } from '@/mocks/manga';

export default function HeroSection() {
  const [searchQuery, setSearchQuery] = useState('');

  return (
    <section className="relative h-[600px] md:h-[700px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20anime%20style%20background%20with%20soft%20peach%20and%20warm%20golden%20gradient%2C%20scattered%20cherry%20blossom%20petals%20floating%2C%20subtle%20manga%20screentone%20texture%20overlay%2C%20dreamy%20atmospheric%20lighting%2C%20abstract%20composition%2C%20clean%20minimal%20aesthetic%2C%20warm%20toned%20illustration%20with%20gentle%20gradients%2C%20no%20text%2C%20no%20characters&width=1920&height=1080&seq=hero-bg-manga&orientation=landscape"
          alt="蜜桃少年漫画背景"
          className="w-full h-full object-cover"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto text-center">
          <p className="text-white/70 text-sm md:text-base tracking-widest mb-4 font-label">
            蜜桃少年漫画 · 土豪漫画网
          </p>
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-heading font-black text-white leading-tight mb-4">
            漫画全集下拉式
            <br />
            <span className="text-primary-300">免费阅读</span>
          </h1>
          <p className="text-white/70 text-base md:text-lg max-w-2xl mx-auto mb-8 leading-relaxed">
            通过土豪漫画网漫画全集下拉式免费阅读蜜桃少年，随时下拉浏览全集中文内容，体验免费且便捷的在线漫画阅读服务。
          </p>

          <div className="max-w-xl mx-auto mb-6">
            <div className="flex items-center gap-2 bg-white/15 backdrop-blur-md rounded-full px-5 py-3 border border-white/20">
              <i className="ri-search-line text-white/60 text-base w-5 h-5 flex items-center justify-center"></i>
              <input
                type="text"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                placeholder="搜索你喜欢的漫画..."
                className="flex-1 bg-transparent text-white placeholder-white/50 text-sm outline-none border-none"
              />
              <button className="bg-primary-500 hover:bg-primary-600 text-white text-sm font-medium px-6 py-2 rounded-full whitespace-nowrap cursor-pointer transition-colors">
                搜索
              </button>
            </div>
          </div>

          <div className="flex flex-wrap items-center justify-center gap-2">
            {hotTags.map((tag, idx) => (
              <Link
                key={tag}
                to="/"
                className={`text-xs md:text-sm px-4 py-1.5 rounded-full whitespace-nowrap transition-all cursor-pointer ${
                  idx === 0
                    ? 'border border-white/40 text-white hover:bg-white/10'
                    : 'text-white/70 hover:text-white hover:bg-white/10'
                }`}
              >
                {tag}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}